// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpiredSignup_container__OkF3Q {
  width: 448px;
  height: 455px;
  padding: 40px;
  box-sizing: border-box;
}

.ExpiredSignup_warning_container__d0EbQ {
  width: 100%;
  height: 315px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
}

.ExpiredSignup_warning_icon__cvY\\+6 {
  color: var(--color-theme-yellow);
  width: 54px !important;
  height: 47px !important;
}

.ExpiredSignup_signup_header__Fp9mV {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 40px;
}

.ExpiredSignup_copy__uFQIB {
  font-size: 22px !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ExpiredSignup/ExpiredSignup.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".container {\n  width: 448px;\n  height: 455px;\n  padding: 40px;\n  box-sizing: border-box;\n}\n\n.warning_container {\n  width: 100%;\n  height: 315px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  text-align: center;\n}\n\n.warning_icon {\n  color: var(--color-theme-yellow);\n  width: 54px !important;\n  height: 47px !important;\n}\n\n.signup_header {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 40px;\n}\n\n.copy {\n  font-size: 22px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ExpiredSignup_container__OkF3Q`,
	"warning_container": `ExpiredSignup_warning_container__d0EbQ`,
	"warning_icon": `ExpiredSignup_warning_icon__cvY+6`,
	"signup_header": `ExpiredSignup_signup_header__Fp9mV`,
	"copy": `ExpiredSignup_copy__uFQIB`
};
export default ___CSS_LOADER_EXPORT___;
